module.exports = __webpack_public_path__ + "static/media/wrongpass-page-login.3786d5ed.png";